import { ENDPOINTS } from '../../apis/endpoints';
import { apiSlice } from '../../app/api/apiSlice';

export const holidayApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getHolidays: builder.query({
      query: () => ({
        url: `${ENDPOINTS.EMPLOYEE.HOLIDAYS}`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetHolidaysQuery } = holidayApiSlice;
